import { checkPermission } from '@/router/guards.ts'

const VoucherModule = () => import('./VoucherModule.vue')
const VoucherIndex = () => import('./views/VoucherIndex.vue')

export const voucherRoute = {
  path: '/vouchers',
  name: 'voucher',
  component: VoucherModule,
  meta: {
    title: 'Vouchers',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'vouchers-index',
      component: VoucherIndex,
      meta: {
        permission: 'voucher.view',
      },
      beforeEnter: checkPermission('voucher.view'),
    },
  ],
}
